import React from "react";
import {makeStyles, Typography, Grid, Box} from "@material-ui/core";
import {useResortPositioningEntriesByIdentifier} from "../../../hooks";
import {useLocation} from "../../../common/common";
import {RESORT_POSITIONING_HOLIDAY_PREFERENCES} from "../../../common/constant";
import {RESORTS} from "../../../common/routes";
import {retrieveContentfulImage} from "../../../common/image";
import {LazyLoadImage} from "react-lazy-load-image-component";

const useStyles = makeStyles((theme) => ({
    gridItem: {
        cursor: "pointer",
        backgroundColor: theme.palette.background.white,
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12), 0px 2px 1px rgba(0, 0, 0, 0.2)",
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1.5),
        height: "100%"
    },
    mt2: {
        marginTop: theme.spacing(1.5)
    },
    imgItem: {
        width: "100%"
    }
}));

const HolidayPreferencesGrid = () => {
    const classes = useStyles();
    const {navigate} = useLocation();
    const {resortPositioningEntries: resortPositioningHolidayPreferencesEntries} = useResortPositioningEntriesByIdentifier(RESORT_POSITIONING_HOLIDAY_PREFERENCES);

    const getSortedHolidayPreferenceEntries = () => {
        return [...(resortPositioningHolidayPreferencesEntries?.resortPositioningEntryCollection?.items)]?.sort((a, b) => (a.orderingForHolidayPreferences > b.orderingForHolidayPreferences) ? 1 : -1);
    };

    return (
        <Grid
            container
            direction="row"
            justify={"center"}
            spacing={2}
        >
            {resortPositioningHolidayPreferencesEntries && getSortedHolidayPreferenceEntries()?.map((holidayPreference) => {
                return (
                    <Grid
                        item
                        key={holidayPreference?.identifier}
                        xs={6}
                        sm={4}
                        md={2}
                        lg={2}
                        xl={2}
                    >
                        <Box
                            className={classes.gridItem}
                            onClick={() => navigate(RESORTS + `/?highlights=${holidayPreference?.identifier}`)}
                            onKeyDown={(event) => {
                                if (event.keyCode === 13 || event.keyCode === 32) {
                                    event.preventDefault();
                                    event.target.click();
                                }
                            }}
                            tabIndex={0}
                        >
                            <Box>
                                <LazyLoadImage
                                    className={classes.imgItem}
                                    draggable={false}
                                    src={retrieveContentfulImage(holidayPreference?.icon?.url, {width: 270, fit: "fill"})}
                                    alt={holidayPreference?.identifier + " icon"}
                                />
                            </Box>
                            <Typography
                                variant="subtitle2"
                                component="div"
                                className={classes.mt2}
                            >
                                {holidayPreference?.title}
                                {holidayPreference?.linkedFrom?.resortCollection?.total &&
                                    <span>
                                        {` (${holidayPreference.linkedFrom.resortCollection.total})`}
                                    </span>
                                }
                            </Typography>
                        </Box>
                    </Grid>
                );
            })}
        </Grid>
    );
};

HolidayPreferencesGrid.propTypes = {

};

export default HolidayPreferencesGrid;
